import {PROTECTED_SELLER_MGM} from 'constants/pageRoutes';

export const kpiData = [
  {name: 'SellerResponsivenessScore', type: 1, translationKey: 'component.seller.kpis.seller'},
  {name: 'DebtorsResponsivenessScore', type: 1, translationKey: 'component.seller.kpis.debtors'},
  {name: 'SponsorshipTotalVolume', type: 1, translationKey: 'component.seller.sponsorship.volume'},
  {name: 'SponsorshipCredits', type: 2, translationKey: 'component.seller.sponsorship.credits', btnTranslationKey: 'seller.kpis.btn.mgm', btnURL: PROTECTED_SELLER_MGM}
];
